/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Payload, SageTransport } from '@tivocorp/tivo-webapp-loggers';
import { Storage } from '../storage/Storage';

export class GlobalCatch {
    private mCatches: any[] = [];

    private mName: string;

    public constructor(name: string) {
        this.mName = name;
        const oCatches = Storage.getInstance().getItem(this.mName);
        if (oCatches) this.mCatches = oCatches;
    }

    // TODO: need to move this to some util.
    private static getLogPrefix(): string {
        const d = new Date();
        const sDate = `${d.getUTCDate()}`.padStart(2, '0');
        const sMonth = `${d.getUTCMonth() + 1}`.padStart(2, '0');
        const sHour = `${d.getUTCHours()}`.padStart(2, '0');
        const sMin = `${d.getUTCMinutes()}`.padStart(2, '0');
        const sSec = `${d.getUTCSeconds()}`.padStart(2, '0');
        const sMili = `${d.getUTCMilliseconds()}`.padStart(3, '0');
        return `${d.getFullYear()}-${sMonth}-${sDate} ${sHour}:${sMin}:${sSec}.${sMili}`;
    }

    parse = ({ colno, error, filename, lineno, message }): void => {
        const primaryStk: string = error?.stack;
        const secondaryStk: string = `${message}\n    at ${filename}:${lineno}:${colno}`;
        let stackTrace = primaryStk || secondaryStk;
        stackTrace = `${GlobalCatch.getLogPrefix()} [GlobalCatch] ${stackTrace}`;
        this.mCatches.push({ referenceTime: Date.now(), stackTrace });
    };

    clear = () => {
        Storage.getInstance().removeItem(this.mName);
        this.mCatches = [];
    };

    getLatestCatch = (): any => {
        return (this.mCatches.length > 0 && this.mCatches[this.mCatches.length - 1]) || null;
    };

    getCatches = (): any[] => {
        return this.mCatches;
    };

    save = (): void => {
        Storage.getInstance().setItem(this.mName, this.mCatches);
    };

    toString = (): string => {
        return `{ "${this.mName}": ${JSON.stringify(this.mCatches)}}`;
    };

    upload = (transport: SageTransport, optional?: Payload) => {
        const payloads = this.mCatches.map(({ referenceTime, stackTrace }) => {
            return new Payload({
                event_name: 'GlobalCatch',
                logType: 'diagnostics',
                referenceTime,
                stackTrace,
            }).merge(optional);
        });

        const promises = payloads.map((payload) => {
            return transport.send(payload);
        });

        return Promise.all(promises)
            .then(() => true)
            .catch(() => false);
    };
}
